"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var CardIcon_component_exports = {};
__export(CardIcon_component_exports, {
  CardIcon: () => CardIcon,
  default: () => CardIcon_component_default
});
module.exports = __toCommonJS(CardIcon_component_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_react = __toESM(require("react"));
var import_useBreakpoints = require("../../../../utils/useBreakpoints/useBreakpoints.hook");
var import_react2 = require("react");
var _templateObject;
var _excluded = ["children"];
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var CardIcon = function CardIcon2(_ref) {
  var children = _ref.children, props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, import_react2.useState)(""), _useState2 = _slicedToArray(_useState, 2), iconTitle = _useState2[0], setIconTitle = _useState2[1];
  var breakpoints = (0, import_useBreakpoints.useBreakpoints)();
  var is400percent = breakpoints.isSm || breakpoints.isXs;
  var rounded = is400percent ? {
    "borderTopLeftRadius": "0.5rem"
  } : {
    "borderTopLeftRadius": "0.5rem",
    "borderBottomLeftRadius": "0.5rem"
  };
  import_react2.Children.map(children, function(child) {
    if (/* @__PURE__ */ (0, import_react2.isValidElement)(child) && child.props.title !== iconTitle) {
      setIconTitle(child.props.title);
    }
  });
  var cardState = ["default", "live"].includes(props.cardState) ? "" : props.cardState || "";
  var ariaLabel = props["aria-label"] || "".concat(cardState, " ").concat(iconTitle);
  return /* @__PURE__ */ import_react.default.createElement(_StyledDiv, _extends({}, props, {
    $_css: [{
      "display": "flex",
      "height": "100%",
      "minHeight": "96px",
      "minWidth": "88px",
      "alignItems": "center",
      "justifyContent": "center",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(221 223 202 / var(--tw-bg-opacity))"
    }, rounded]
  }), /* @__PURE__ */ import_react.default.createElement(_StyledSpan, null, ariaLabel), /* @__PURE__ */ import_react.default.createElement(_StyledDiv2, {
    "aria-hidden": true
  }, children));
};
var CardIcon_component_default = CardIcon;
var _StyledDiv = (0, import_styled_components.default)("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function(p) {
  return p.$_css;
});
var _StyledSpan = (0, import_styled_components.default)("span")({
  "position": "absolute",
  "width": "1px",
  "height": "1px",
  "padding": "0",
  "margin": "-1px",
  "overflow": "hidden",
  "clip": "rect(0, 0, 0, 0)",
  "whiteSpace": "nowrap",
  "borderWidth": "0"
});
var _StyledDiv2 = (0, import_styled_components.default)("div").withConfig({
  displayName: "CardIconcomponent___StyledDiv2",
  componentId: "sc-1a9vn4y-0"
})({
  "height": "40px",
  "width": "40px"
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CardIcon
});
//# sourceMappingURL=CardIcon.component.js.map